// extracted by mini-css-extract-plugin
export default {"external":"awbKM7","deprecatedBorderRadius":"bwbKM7","hasAnimation":"cwbKM7","container":"dwbKM7"};